import React from 'react';
// components
import { Outlet } from 'react-location';

const VoicemailParentPage = () => <Outlet />;

export default VoicemailParentPage;
